module.exports = __webpack_public_path__ + "static/media/pinterest.d82d597c.svg";